import globalAxios from 'axios';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const BASE_PATH = "https://flex-gateway.dev.flexis.team".replace(/\/+$/, "");
class BaseAPI {
  constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
    this.basePath = basePath;
    this.axios = axios;
    __publicField(this, "configuration");
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}
class RequiredError extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    __publicField(this, "name", "RequiredError");
  }
}

export { BASE_PATH, BaseAPI, RequiredError };
//# sourceMappingURL=base.mjs.map
